import React, { Component } from "react";
import { Fab, Grid, Hidden } from "@material-ui/core";
import { primaryColor } from "../../config/theme";
import { Clear } from "@material-ui/icons";

class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientWidth: props.clientWidth ? props.clientWidth : 510,
    };
  }

  render() {
    let { url, onDelete, videoId, page } = this.props;

    return (
      <div
        style={page === 'portfolio' ? styles.addMediaBoxPortfolio : page === "post" ? styles.addMediaBoxPost : page === 'add-dish' ? styles.addMediaBoxDish : styles.addMediaBox}
        className={page === 'portfolio' ? this.props.clientWidth < 500 ? "media-cutom-col-step" : "media-cutom-col" : ""}>
        <Fab
          color="primary"
          aria-label="delete"
          component="span"
          size="small"
          style={{ position: "absolute", padding: 0, marginTop: "20px" }}
          onClick={() => onDelete()}
        >
          <Clear style={{ color: "white" }} />
        </Fab>
        <Hidden smDown>
          {videoId ? (
            <iframe
              src={`https://player.vimeo.com/video/${videoId}`}
              width={this.props.clientWidth > 600 ? 278 : 255}
              height="280"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen></iframe>) : (<img
            src={url}
            alt="upload file"
            style={{ width: "100%", height: "100%", maxHeight: page === "post" ? 240 :'100%' }}
          />)}
        </Hidden>
        <Hidden mdUp>
          {videoId ? (
            <iframe
              src={`https://player.vimeo.com/video/${videoId}`}
              width="255"
              height="280"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen></iframe>) : (<img
            src={url}
            alt="upload file"
            style={{ width: "100%", height: "100%", maxHeight: page === "post" ? 240 :'100%' }}
          />)}
        </Hidden>
      </div>
    );
  }
}

export default Image;
const styles = {
  addMediaBoxPost: {
    maxWidth: 320,
    maxHeight: 240,
    borderWidth: 1,
    borderColor: primaryColor,
    borderStyle: "solid",
    marginRight: 5,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    marginBottom: 10,
  },
  addMediaBoxDish: {
    maxWidth: 320,
    maxHeight: 240,
    borderWidth: 1,
    borderColor: primaryColor,
    borderStyle: "solid",
    marginRight: 5,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    marginBottom: 10,
  },
  addMediaBox: {
    maxWidth: 210,
    maxHeight: 140,
    borderWidth: 1,
    borderColor: primaryColor,
    borderStyle: "solid",
    marginRight: 5,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    marginBottom: 10,
  },
  addMediaBoxPortfolio: {
    width: 280,
    height: 280,
    borderWidth: 1,
    borderColor: primaryColor,
    borderStyle: "solid",
    marginRight: 7,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    marginBottom: 10,
    flexDirection: 'row'
  },
  deleteIcon: {}
};
